import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { AiAssistantPromptPreset } from '@domain/ai-assistant/ai-assistant.models';
import { AI_SUGGESTION_KEYS } from '@domain/ai-assistant/ai-suggestions';

import { UpPipe } from '@shared/pipes/up/up.pipe';

import { appAi52Icon } from '@icons/ai-52';
import { appChevronDownV224Icon } from '@icons/chevron-down-v2-24';
import { appCloseV224Icon } from '@icons/close-v2-24';
import { appDrag32Icon } from '@icons/drag-32';
import { appFullScreen24Icon } from '@icons/full-screen-24';

import { AiAssistantService } from '../../ai-assistant.service';
import { AiAssistantPromptPresetsComponent } from '../ai-assistant-prompt-presets/ai-assistant-prompt-presets.component';
import { AiAssistantSidebarComponent } from '../ai-assistant-sidebar/ai-assistant-sidebar.component';
import { AiComposerComponent, AiComposerMessage } from '../ai-composer/ai-composer.component';
import { AiMessageListComponent } from '../ai-message-list/ai-message-list.component';

@Component({
  selector: 'app-ai-assistant-window',
  imports: [
    SvgIconComponent,
    AiMessageListComponent,
    AiComposerComponent,
    TranslatePipe,
    UpPipe,
    AiAssistantSidebarComponent,
    AiAssistantPromptPresetsComponent,
    DragDropModule,
  ],
  templateUrl: './ai-assistant-window.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      // eslint-disable-next-line max-len
      'flex flex-col bg-[#EDEFF7] dark:bg-background-main lg:rounded-radius-primary max-lg:rounded-none drop-shadow-foreground-primary-100-shadow-30 relative z-0 overflow-hidden h-full lg:w-[420px] lg:h-[600px]',
  },
})
export class AiAssistantWindowComponent {
  public readonly aiService = inject(AiAssistantService);
  public readonly suggestionKeys = AI_SUGGESTION_KEYS;
  public readonly composerValue = signal('');
  public readonly showSideMenu = signal(false);

  constructor() {
    injectRegisterIcons([appFullScreen24Icon, appChevronDownV224Icon, appCloseV224Icon, appAi52Icon, appDrag32Icon]);
  }

  public onExpand(): void {
    this.aiService.expand();
  }

  public onClose(): void {
    this.aiService.close();
  }

  public onOpenSideMenu(): void {
    this.aiService.openSideMenu();
    this.showSideMenu.set(true);
  }

  public onCloseSideMenu(): void {
    this.showSideMenu.set(false);
  }

  public onSuggestionClicked(text: string): void {
    if (!this.composerValue().trim()) {
      this.composerValue.set(text);
    }
  }

  public onMessageSent(message: AiComposerMessage): void {
    this.aiService.send(message.message, message.uiContext);
  }

  public onPromptPresetSelected(promptPreset: AiAssistantPromptPreset): void {
    this.aiService.runPromptPreset(promptPreset);
  }
}
